// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')
// Other Components

// Management
const ManageUserPage = () => import('@/modules/users/views/management/ManageUserPage')
const ManageUserList = () => import('@/modules/users/views/management/ManageUserList')
const ManageInactiveUserList = () => import('@/modules/users/views/management/ManageInactiveUserList')
const ManageAccountManagerUserList = () => import('@/modules/users/views/management/ManageAccountManagerUserList')
const ManageUserSettings = () => import('@/modules/users/views/management/ManageUserSettings')
const MyLeads = () => import('@/modules/users/views/MyLeads')
const MyDocusigns = () => import('@/modules/users/views/MyDocusigns')


var routes = [
    {
        path: '/users/manage',
        redirect: '/users/manage',
        name: 'ManageUsers',
        component: DefaultContainer,
        children: [
			{
				path: '/users/manage',
				name: 'ManageUserPage',
				redirect: '/users/manage/list',
				component: ManageUserPage,
				meta: {
					requiresAuth: true,
					permission: false,
				},
				children: [
					{
						path: 'list',
						name: 'ManageUserList',
						component: ManageUserList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'user-active-list'
						},
					},
					{
						path: 'inactive',
						name: 'ManageInactiveUserList',
						component: ManageInactiveUserList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'user-inactive-list'
						},
					},
					{
						path: 'account-manager',
						name: 'ManageAccountManagerUserList',
						component: ManageAccountManagerUserList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'account-manager-list'
						},
					},
				],
			},
			{
				path: ':user_id',
				name: 'ManageUserSettings',
				component: ManageUserSettings,
				meta: {
					requiresAuth: true,
					permission: false,
				}
			},
		],
    },
	{
		path: '/common/my-docusigns',
		redirect: '/common/my-docusigns',
		component: DefaultContainer,
		children: [
            {
                path: '/common/my-docusigns',
                name: 'MyDocusigns',
                component: MyDocusigns,
                meta: {
                    requiresAuth: true,
                    permission: false,
                },
            },
		]
	},
	{
		path: '/common/my-leads',
		redirect: '/common/my-leads',
		component: DefaultContainer,
		children: [
            {
                path: '/common/my-leads',
                name: 'MyLeads',
                component: MyLeads,
                meta: {
					requiresAuth: true,
                    permission: false,
					role_filter: 'closer',
                },
            },
		]
	},
	
];

export default routes;
